import { whichTransitionEvent } from '../utils';


class Sidebar {
  constructor(observable, template) {
    this.observable = observable;
    this.template = template;
    this.sidebar = document.getElementById('sidebar');
    this.sidebarContent = this.sidebar.querySelector('.sidebar__content');
    this.closeButton = this.sidebar.querySelector('.sidebar__close');
    this.close = this.close.bind(this);
    this.body = document.body;
    this.transitionEvent = whichTransitionEvent();

    this.locationLinks = this.sidebar.querySelectorAll('.location-link');

    this.sidebarActive = false;
    this.contentLoaded = false;

    this.handleCloseButton = this.handleCloseButton.bind(this);

    this.init();
  }

  init() {
    this.bindEventListeners();
  }

  bindEventListeners() {
    this.closeButton.addEventListener('click', this.handleCloseButton);

    this.sidebar.addEventListener('click', (e) => {
      // check if clicked element is a link
      if(e.target && e.target.dataset.locationId) {
        this.observable.publish('location-selected', e.target.dataset.locationId);
      }
    });
  }

  update(info) {
    if(this.sidebarActive) {
      this.closeContent().then(res => {
        this.appendContent(info).then(res => {
          this.openContent();
        });
      });
    } else {
      this.appendContent(info).then(res => {
        this.openContent();
      });
    }
  }

  openContent() {
    return new Promise((resolve, reject) => {
      const openSlider = () => {
        this.sidebarContent.removeEventListener(this.transitionEvent, openSlider);
        resolve('open content');
      }

      this.sidebarContent.classList.add('active');
      this.sidebarContent.addEventListener(this.transitionEvent, openSlider);
    });
  }

  closeContent() {
    return new Promise((resolve, reject) => {
      const closeSlider = () => {
        this.sidebarContent.removeEventListener(this.transitionEvent, closeSlider);
        resolve('closed content');
      }

      this.sidebarContent.classList.remove('active');
      this.sidebarContent.addEventListener(this.transitionEvent, closeSlider);
    });
  }

  appendContent(info) {
    return new Promise((resolve, reject) => {
      this.sidebarContent.innerHTML = this.getTemplate(info);

      // scroll sidebar to the top.
      this.sidebar.scrollTop = 0;
      resolve('appended content');
    });
  }

  open() {
    this.sidebar.classList.add('active');
    this.body.classList.add('no-scroll');
    this.body.classList.add('is-sidebar-open');
    this.sidebarActive = true;
  }

  close() {
    this.sidebar.classList.remove('active');
    this.body.classList.remove('no-scroll');
    this.body.classList.remove('is-sidebar-open');
    this.sidebarActive = false;
  }

  handleCloseButton() {
    this.close();
    this.observable.publish('sidebar-closed');
  }

  getTemplate(info) {
    return this.template(info);
  }
}

export default Sidebar;